import fetch from './fetch'
import * as api from '../config/api'
import download from './download'

export const getAgendas = function(year = null, month = null, pimpinan = 0) {
  return new Promise((resolve, reject) => {
    const params = {
      year,
      month,
      pimpinan
    }
    fetch
      .get(api.agenda, { params })
      .then(({ data }) => {
        const dataAgenda = data
          .filter(dt => dt.tgl)
          .map(dt => ({
            ...dt,
            title: dt.perihal_surat || dt.nama_agenda || '-',
            start: `${dt.tgl} ${dt.waktu}`,
            end: dt.tgl_selesai
              ? `${dt.tgl_selesai} ${
                  dt.waktu_selesai ? dt.waktu_selesai : '00:00'
                }`
              : null,
            backgroundColor: dt.surat_id ? '#F44336' : '#FF9800',
            borderColor: dt.surat_id ? '#F44336' : '#FF9800',
            from: dt.pengirim_surat || dt.pengundang || '-'
          }))
        resolve(dataAgenda)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const addAgenda = async (data = {}) => await fetch.post(api.agenda, data)

export const updateAgenda = async (id = '', data = {}) =>
  await fetch.put(`${api.agenda}/${id}`, data)

export const deleteAgenda = async (id = '') =>
  await fetch.delete(`${api.agenda}/${id}`)

export const getReportAgenda = async (params = {}) => {
  return await download(
    api.reportAgenda,
    params,
    `Laporan Agenda ${params.from} s.d. ${params.to}`
  )
}
